<template>
	<div 
		class="textarea-input"
		:class="[
			darkMode ? 'dark-mode' : ''
		]"
		>
		<label>{{ label }}</label>
		<textarea  
			:value="modelValue"
			@input="$emit('update:modelValue', $event.target.value)" 
			ref="input"
			:maxLength="maxLength ? maxLength : 9999999"
			/>
		
		<div 
			class="max-length-data" 
			v-if="maxLength"
			:class="{
				'getting-close': currentLength > (maxLength * 0.7),
				'maxed-out': currentLength == maxLength
			}"
			>
			{{ maxLength - currentLength }} characters left
		</div>
	</div>
</template>

<script>
	export default {
		props: [
			'label',
			'modelValue',
			'maxLength',
			'darkMode',
		],
		emits: ['update:modelValue'],
		methods: {
			focus() {
				this.$refs.input.focus()
			}
		},
		computed: {
			currentLength(){
				return this.modelValue.length
			}
		}
	}
</script>

<style lang="sass" scoped>

.textarea-input
	margin: 0 0 30px
	display: flex
	flex-direction: column
	width: 100%
	// max-width: 30rem

	label
		font-family: 'Roboto Condensed', sans-serif
		font-weight: 700
		font-size: 16px
		line-height: 1.1
		color: #252525
		margin-bottom: 10px

	textarea
		border-radius: 3px
		border: 1px solid lighten(#111, 70%)
		box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05)
		width: 100%
		max-width: 100%
		min-width: 100%
		height: auto
		min-height: 120px
		max-height: 500px

	.max-length-data
		font-size: 14px
		font-family: 'Roboto Condensed', sans-serif
		font-weight: 400
		margin-top: 10px
		width: 100%
		display: block
		text-align: right
		color: #486C84
		transition: all 700ms

		&.getting-close
			color: #ff9000

		&.maxed-out
			color: #f00

	&.dark-mode
		label
			color: rgba(#fff, 0.7)

		textarea
			background-color: rgba(#fff,0.2)
			color: #fff

			&::placeholder
				color: rgba(#fff,0.6)
		


</style>

